// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"6d8d13a2","389":"6d8d13a2","405":"6d8d13a2","546":"6d8d13a2"}[chunkId] + ".chunk.css";
};